import { EventEmitter } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { TrackerService } from '@shared/services/tracker.service';

export class CancelPopinVM {
  constructor(
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {}

  continueProcess(continueEmitter: EventEmitter<void>) {
    this.tracker.trackClick({
      click: frenchi18n.cancel,
      taggingPage: 'ABANDON_BANK_CONNECTION',
    });

    continueEmitter.emit();
  }

  rejected() {
    this.tracker.trackClick({
      click: frenchi18n.continue,
      taggingPage: 'ABANDON_BANK_CONNECTION',
    });

    this.processEventService.push(ProcessEventFactory.SpawnAbandonEvent());
  }
}
